
  import { FileProcess } from '@/entities/files'
  import { plainToInstance } from 'class-transformer'
  import { Component } from 'vue-property-decorator'
  import Cell from './cell'

@Component
  export default class EmployeeNameCell extends Cell {
    photo: FileProcess = plainToInstance(FileProcess, {})

    async mounted () {
      const { item } = this

      this.photo = (await this.fetchData({
        query: { name: 'find', model: 'FileProcess' },
        filter: {
          _and: [
            { id_process_record: { _eq: item.person.id } },
            { parameter: { process: { table_name: { _eq: 'person' } } } },
          ],
        },
        force: true,
      }))[0]
    }
  }
